import React,{Component} from 'react';
import './buttonCheckBoxStyle.css';


/**
 * 多选按钮组件
 */
class ButtonCheckBox extends  Component{
   constructor(props){
       super(props);
       this.state={
            selectData:this.props.checkedData,
            selectValues:this.getSelectValues(this.props.checkedData),
       }
   }

    getSelectValues(data) {
        var selectValues = [];
        if (data) {
            for (var i = 0; i < data.length; i++) {
                selectValues.push(data[i][this.props.value]);
            }
        }
        return selectValues;
    };

   componentWillReceiveProps(nextProps, nextContext) {
       if(nextProps.checkedData){
          this.setState({
              selectData:nextProps.checkedData,
              selectValues:this.getSelectValues(nextProps.checkedData),
          });
       }
   }

    onSelect(item){
       const key=this.props.value;
       console.info('onSelect'+item);
       let selectValues=this.state.selectValues?this.state.selectValues:[];
       let selectData=this.state.selectData?this.state.selectData:[];
       var index=selectValues.indexOf(item[key]);
       if(index>-1){
           selectValues.splice(index,1);
           selectData.splice(index,1);
       }else{
           selectValues.push(item[key]);
           selectData.push(item);
       }
       this.setState({
           selectData,
           selectValues
       })

       this.props.getSelectData(selectData,this.props.dataType);
   }

   render() {
       const selectVlues=this.state.selectValues;
       const key=this.props.value;
       const name=this.props.name;
       return <div className={'checkbox_container'}>
           {this.props.dataSource.map((item,index)=>{
               if(selectVlues.indexOf(item[key])>-1){
                   return <div onClick={()=>this.onSelect(item)} key={index} className={'selectButton'}>{item[name]}</div>
               }else{
                   return <div key={index} onClick={()=>this.onSelect(item)} className={'unSelectButton'}>{item[name]}</div>
               }
           })}
       </div>
   }
}

export default  ButtonCheckBox;